// Troubleshoot your routes using this - https://paths.esm.dev

/** @type {import('vue-router').RouterOptions['routes']} */

const names = {
  map: "Map",
};

export { names as mapRouteNames };

const mapRoutes = [
  {
    path: "/map",
    name: names.map,
    meta: { title: "Map" },
    component: () => import("@/views/map/Map.vue"),
  },
];
export default mapRoutes;
